var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_44271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.125 80.5C71.3016 80.5 69.553 79.7757 68.2636 78.4864C66.9743 77.197 66.25 75.4484 66.25 73.625V7.375C66.25 5.55164 65.5257 3.80295 64.2364 2.51364C62.947 1.22433 61.1984 0.5 59.375 0.5L6.875 0.5C8.69836 0.5 10.447 1.22433 11.7364 2.51364C13.0257 3.80295 13.75 5.55164 13.75 7.375V73.6578C13.7461 74.5528 13.9186 75.4399 14.2576 76.2682C14.5967 77.0965 15.0956 77.8499 15.726 78.4853C16.3563 79.1208 17.1057 79.6257 17.9313 79.9714C18.7569 80.3171 19.6425 80.4967 20.5375 80.5H73.125Z",
    fill: "url(#paint0_linear_347_44271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.375C13.75 5.55164 13.0257 3.80295 11.7364 2.51364C10.447 1.22433 8.69836 0.5 6.875 0.5C5.05164 0.5 3.30295 1.22433 2.01364 2.51364C0.724328 3.80295 0 5.55164 0 7.375L0 10.5H13.75V7.375Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.125 70.5H27.5V73.625C27.5 75.4484 26.7757 77.197 25.4864 78.4864C24.197 79.7757 22.4484 80.5 20.625 80.5H73.125C74.9484 80.5 76.697 79.7757 77.9864 78.4864C79.2757 77.197 80 75.4484 80 73.625V70.5H73.125Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.375 70.5H33.5312C33.5312 70.5 24.9125 80.5 21.6 80.5H73.3812C76.6812 80.7 79.3875 77.7625 79.3875 73.975V70.5H73.375Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.12505H59.375C61.1984 1.12505 62.947 1.84937 64.2364 3.13869C65.5257 4.428 66.25 6.17668 66.25 8.00005V7.37505C66.25 5.55168 65.5257 3.803 64.2364 2.51369C62.947 1.22437 61.1984 0.500045 59.375 0.500045H6.875C7.85938 0.496432 8.83247 0.709827 9.725 1.12505H13.75Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.125 79.875H23.4625C22.5725 80.2847 21.6047 80.4979 20.625 80.5H73.125C74.9484 80.5 76.697 79.7757 77.9864 78.4864C79.2757 77.197 80 75.4484 80 73.625V73C80 74.8234 79.2757 76.572 77.9864 77.8614C76.697 79.1507 74.9484 79.875 73.125 79.875Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.2437 36.6885L56.725 27.0947L36.3187 47.501L59.325 70.4885L66.2375 70.501L66.2437 36.6885Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.5421 37.4799C28.8398 37.1826 29.2433 37.0156 29.664 37.0156C30.0847 37.0156 30.4882 37.1826 30.7859 37.4799L38.4 45.0956C38.5473 45.2427 38.6642 45.4175 38.744 45.6098C38.8237 45.8022 38.8648 46.0084 38.8648 46.2167C38.8648 46.4249 38.8237 46.6311 38.744 46.8235C38.6642 47.0158 38.5473 47.1906 38.4 47.3377C38.2527 47.4852 38.0778 47.6021 37.8853 47.6819C37.6928 47.7616 37.4865 47.8027 37.2781 47.8027C37.0697 47.8027 36.8634 47.7616 36.6709 47.6819C36.4784 47.6021 36.3035 47.4852 36.1562 47.3377L28.5453 39.719C28.2482 39.4223 28.081 39.0199 28.0804 38.6001C28.0799 38.1803 28.2459 37.7774 28.5421 37.4799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1999 47.3748C35.9087 47.079 35.7455 46.6805 35.7455 46.2654C35.7455 45.8503 35.9087 45.4518 36.1999 45.156L54.3249 27.031C54.4717 26.8841 54.6459 26.7674 54.8378 26.6879C55.0296 26.6083 55.2352 26.5674 55.4429 26.5674C55.6506 26.5674 55.8562 26.6083 56.0481 26.6879C56.2399 26.7674 56.4142 26.8841 56.5609 27.031C56.8582 27.3287 57.0252 27.7322 57.0252 28.1529C57.0252 28.5736 56.8582 28.9771 56.5609 29.2748L38.4359 47.3998C38.1353 47.6914 37.7316 47.8524 37.3128 47.8477C36.894 47.8431 36.494 47.6731 36.1999 47.3748Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_347_44271",
    x1: 12.4156,
    y1: 1.05937,
    x2: 66.8094,
    y2: 78.8656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64DD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#388E3C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_44271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListLogo);
export default __webpack_public_path__ + "static/media/list-logo.2065bed00cd9bcad438e196930911c20.svg";
export { ForwardRef as ReactComponent };